import { createContext } from 'react';
import { Location, NavigateFunction } from 'react-router-dom';

const DropdownNavContext = createContext({
    location: {} as Location,
    navigate: {} as NavigateFunction,
});

export default DropdownNavContext;
